import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WastyAdmin from "./components/Wasty/WastyAdmin.tsx";
import BulkBarcode from "./Apps/BulkBarcode.tsx";
import PrivacyPolicy from "./components/Wasty/privacyPolicy.tsx";
import MegasusFoundation from "./components/Megasus/index.tsx";


 const App =()=>{

  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<BulkBarcode />} /> */}
        {/* <Route path="/" element={<WastyAdmin />} /> */}
          <Route path="/" element={<MegasusFoundation />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  )
}
export default App